<!-- IMAGE -->
@if (resolution() === 'responsive') {
<picture>
    <source [srcset]="`${src()}/${IMAGE_RESOLUTION.fhd}`" media="(min-width: 1920px)" />
    <source [srcset]="`${src()}/${IMAGE_RESOLUTION.xl}`" media="(min-width: 1080px)" />
    <source [srcset]="`${src()}/${IMAGE_RESOLUTION.lg}`" media="(min-width: 512px)" />
    <source [srcset]="`${src()}/${IMAGE_RESOLUTION.md}`" media="(max-width: 511px)" />
    <ng-container *ngTemplateOutlet="imageTemplate, context: { $implicit: { resolution: IMAGE_RESOLUTION.original } }" />
</picture>
} @else {
<ng-container *ngTemplateOutlet="imageTemplate, context: { $implicit: { resolution: resolution() } }" />
}

<!-- IMAGE TEMPLATE -->
<ng-template #imageTemplate let-image>
    <img #image [class]="['image', fit(), ...imageClasses()]" [height]="defaultHeight()" [width]="defaultWidth()"
        [alt]="alt()" draggable="false" [src]="imageSource()" />
</ng-template>